<template>
    <ActionText>{{creatorDescription}} skipped this athlete {{createdDate | ago}}</ActionText>
</template>

<script>
import ActionText from './ActionText'
import { mapGetters } from 'vuex'

export default {
    components: { ActionText },

    computed: {
        ...mapGetters('userData', ['userId']),
        ...mapGetters('athleteProfile', ['skips']),

        skip() {
            return this.skips[0]
        },

        creator() {
            return this.skip.creator
        },

        creatorDescription() {
            return this.creator.id == this.userId
                ? 'You'
                : `${this.creator.firstName} ${this.creator.lastName}`
        },

        createdDate() {
            return this.skip.createdDate
        },
    }    
}
</script>